import { DropdownInputTemplate, DropdownInputTemplateProps } from "./template";

export type DropdownInputProps = DropdownInputTemplateProps;

export const DropdownInput = (props: DropdownInputProps): JSX.Element => {
  return <DropdownInputTemplate {...props} />;
};
